import React, { useEffect, useState } from "react";
import axios from "axios";
import { getMessage, updateMessage } from "../services/auth";

const Message = () => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" }); // { type: 'success' | 'error', message: string }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getMessage();
        console.log(data.message);
        setMessage(data.message);
      } catch (err) {
        setStatus({ type: "error", message: err.message });
      }
    };
    fetchData();
  }, []);

  const handleUpdate = async () => {
    if (message.trim() === "") {
      setStatus({ type: "error", message: "Message cannot be empty." });
      return;
    }

    try {
      setLoading(true);
      await updateMessage(message);
      setStatus({ type: "success", message: "Message updated successfully." });
    } catch (error) {
      setStatus({ type: "error", message: "Failed to update message." });
      console.error("Update error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (status.message) {
      const timer = setTimeout(() => {
        setStatus({ type: "", message: "" });
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [status.message]);

  return (
    <div className="p-8 max-w-2xl mx-auto">
      <h1 className="text-2xl font-semibold mb-4">Type your message</h1>

      {status.message && (
        <div
          className={`mb-4 p-3 rounded ${
            status.type === "success"
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {status.message}
        </div>
      )}

      <textarea
        className="w-full p-4 border rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-indigo-500"
        rows={8}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Enter your message here..."
      />
      <button
        onClick={handleUpdate}
        disabled={loading}
        className="mt-4 px-6 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition-colors disabled:opacity-50"
      >
        {loading ? "Updating..." : "Update Message"}
      </button>
    </div>
  );
};

export default Message;
